import * as React from 'react';
import cn from 'classnames';
import { Close } from '@mos-cat/icon';
import Portal from '@mos-cat/portal';
import './styles/Modal.scss';
/**
 * ВНИМАНИЕ!
 * если присутствуют несколько вложенных onClick
 * возможен глюк event.target !== event.currentTarget, так как event.currentTarget будет меняться каждый клик
 * */
function Modal(props) {
    var _a;
    var visible = props.visible, children = props.children, className = props.className, onClose = props.onClose, headerContent = props.headerContent, mobileFooterContent = props.mobileFooterContent;
    var wrapClassName = cn((_a = {
            Modal__wrapper: true,
            Modal__wrapper_show: visible
        },
        _a[className + "__wrapper"] = className,
        _a));
    var componentClassNames = cn({
        Modal: true
    }, className);
    var handleClick = function (event) {
        if (event.target !== event.currentTarget)
            return;
        onClose(event, 'mask');
    };
    return (React.createElement(Portal, null,
        React.createElement("div", { tabIndex: -1, className: wrapClassName, role: "dialog" },
            React.createElement("div", { onClick: handleClick, className: "Modal__mask" }),
            React.createElement("div", { role: "document", className: componentClassNames },
                React.createElement("div", { className: "Modal__header" },
                    headerContent,
                    React.createElement("button", { "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", className: "Modal__closeBtn", type: "button", onClick: function (event) { return onClose(event, 'button'); } },
                        React.createElement(Close, { className: "Modal__close" }))),
                React.createElement("div", { className: "Modal__content" },
                    React.createElement("div", { className: "Modal-body" }, children)),
                React.createElement("div", { className: "Modal__mobileFooter" }, mobileFooterContent)))));
}
Modal.defaultProps = {
    className: '',
    headerContent: null,
    mobileFooterContent: null
};
export default Modal;
//# sourceMappingURL=Modal.js.map